import { render, staticRenderFns } from "./imagepicker.vue?vue&type=template&id=857c2722&scoped=true"
import script from "./imagepicker.vue?vue&type=script&lang=js"
export * from "./imagepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857c2722",
  null
  
)

export default component.exports